import React from 'react'
import { createRole } from '../../../Apis/rolesApi';
import Form from './Form';

export default function AddRole(props) {
    const onSubmit = async (e, data) => {
        e.preventDefault();
        //to send request
        return await createRole(data).then(res => {
            props.getAll();
            return 'done';          
        }).catch(err =>{
            console.log(err.response);
            return err.response.data.errors;
        })
    };

    return(
        <div className='actionCardSideWrapper'>
            <Form onSubmit={onSubmit}/>
        </div>
    )
}
